(function () {
  if (customElements.get('ce-ticker') !== undefined) {
    return;
  }

  class Ticker extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        tape: '[data-ticker-tape]',
      };

      this.elements = null;
      this.resizeObserver = null;
    }

    parsedCallback() {
      this.elements = {
        tape: this.querySelector(this.selectors.tape),
      };

      const callback = (entries) => {
        for (let entry of entries) {
          const duration = Math.round(entry.contentRect.width * parseFloat(this.dataset.transformProportion) * 7.5 * parseFloat(this.dataset.modifier));
          entry.target.style.setProperty('--duration', `${duration}ms`);
        }
      };

      this.resizeObserver = new ResizeObserver(callback);
      this.resizeObserver.observe(this.elements.tape);
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
    }
  }

  customElements.define('ce-ticker', Ticker);
})();
